import React,{useState,useEffect} from 'react';
import {fetchCountries} from './api/index';
const CountryPicker = ({handleCountryChange}) => {
    const [fetchedCountries,setFetchedCountries]=useState([]);
    useEffect(()=>{
        const fetchAPI=async()=>{
            setFetchedCountries(await fetchCountries());
        }
        fetchAPI();
    },[setFetchedCountries])
    return (
        <div>
            <select class="custom-select" id="inputGroupSelect01" defaultValue="" onChange={(e)=>handleCountryChange(e.target.value)}>
            <option value="">Global data</option>
            {fetchedCountries.map((country,i)=><option value={country} key={i}>{country}
                </option>)}
            </select>
        </div>
    )
}

export default CountryPicker
